// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1m-q";
export var animationRelative = "_1m-p";
export var backdropBlur = "_1m-0";
export var detailLabelCell = "_1m-12";
export var detailTable = "_1m-11";
export var detailValueCell = "_1m-13";
export var docIconBox = "_1m-1d";
export var docIconBoxMd = "_1m-1f";
export var docIconBoxSm = "_1m-1e";
export var docTypeRow = "_1m-16";
export var docTypeRowInner = "_1m-17";
export var dropdownMatchDatePicker = "_1m-3";
export var evidenceCardContent = "_1m-1c";
export var fileUploadSpin = "_1m-j";
export var gorgiasOpenButton = "_1m-15 _1m-d";
export var gorgiasTicketCard = "_1m-14";
export var heroModalFooterButton = "_1m-18";
export var hiddenContainer = "_1m-o";
export var iconPrimary = "_1m-1g";
export var iconSecondary = "_1m-1h";
export var iconTertiary = "_1m-1i";
export var integrationCard = "_1m-1";
export var integrationLogoBox = "_1m-2";
export var mainColumnSticky = "_1m-1b";
export var maxWidthContainer = "_1m-19";
export var modalContentBody = "_1m-a";
export var modalHeaderImage = "_1m-5";
export var modalImageLabel = "_1m-7";
export var modalImageOverlay = "_1m-6";
export var modalImageSubtitle = "_1m-9";
export var modalImageTitle = "_1m-8";
export var modalImageWrapper = "_1m-4";
export var modalStickyFooter = "_1m-b";
export var removeButton = "_1m-e";
export var sidebarColumn = "_1m-1a";
export var spinner = "_1m-i";
export var timelineLine = "_1m-y";
export var timelineLineBlack = "_1m-10 _1m-y";
export var timelineLineGray = "_1m-z _1m-y";
export var timelineLineHeight = "_1m-x";
export var tlDotActivate = "_1m-u";
export var tlDotActivateAnim = "_1m-t";
export var tlDotHide = "_1m-s";
export var tlDotHideAnim = "_1m-r";
export var tlLineActivate = "_1m-w";
export var tlLineActivateAnim = "_1m-v";
export var uploadHint = "_1m-n";
export var uploadIconBox = "_1m-k";
export var uploadLabel = "_1m-m";
export var uploadText = "_1m-l";
export var uploadZone = "_1m-f";
export var uploadZoneCursorDefault = "_1m-h";
export var uploadZoneCursorPointer = "_1m-g";
export var uploadedFileRow = "_1m-c";
export var viewButton = "_1m-d";